module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('label', [_vm._v(_vm._s(_vm.campaign.name))]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Статистика задач")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("В очереди")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.campaignProgress.ready))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Вызов")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.campaignProgress.dialing))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Идет разговор")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.campaignProgress.ongoing))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Выполнена")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.campaignProgress.performed))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Недозвон")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.campaignProgress.failed))])])])])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Метрики прозвона")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Скорость выполнения")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.campaignProgress.performingSpeed))])])])])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._m(2), _vm._v(" "), _c('span', [_vm._v("Закрыть")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Состояние")]), _vm._v(" "), _c('th', [_vm._v("Количество")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Метрика")]), _vm._v(" "), _c('th', [_vm._v("Значение")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f977fc9c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/campaigns/CampaignMonitoring.vue
// module id = 475
// module chunks = 40